import { useState } from "react";
const usePagination = (
  initialPage = 1,
  initialPageSize = 10,
  initialTotalElements = 0
) => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [totalElements, setTotalElements] = useState(initialTotalElements);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };
  return {
    currentPage,
    pageSize,
    totalElements,
    setTotalElements,
    handleTableChange,
    setCurrentPage,
    setPageSize,
    setCurrentPage
  };
};
export default usePagination;